<template>
  <div class="video-page">
    <VideoScale
      ref="videoScale"
      @tagChange="tagChange"
      :width="900"
      :height="500"
    />
    <a-spin :spinning="spinning">
      <div class="page-bottom">
        <a-button type="primary" @click="playSomeTags">
          播放正方形、圆形片段
        </a-button>
      </div>
      <div class="page-bottom">
        <a-tag
          v-for="tag in tags"
          :key="tag.index"
          @click="tagClick(tag)"
          :color="tag.index === curTag.index ? 'green' : ''"
        >
          {{ tag.name }}
        </a-tag>
      </div>
    </a-spin>
    <div>
      <p style="font-size:16px; padding: 20px 0;font-weight:bold">
        所有互动事件
      </p>
      <table class="event-table">
        <tr>
          <th>互动名称</th>
          <th>位置</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item, index) in eventList" :key="index">
          <td>{{ item.name }}({{ item.type }})</td>
          <td>{{ item.position }}</td>
          <td>
            <a href="javascript:;" @click="interactClick(item)">查看互动</a>
          </td>
        </tr>
      </table>
      <div class="interact-wrap" v-if="curEvent">
        <!-- 互动 -->
        <component
          :is="curInteract"
          :event="curEvent"
          @realEnd="end"
        />
      </div>
    </div>
  </div>
</template>
<script>
import VideoScale from '@/components/VideoPlayer/videoScale.vue'
import getEvent from '@/components/VideoPlayer/interact/getEvent.js'
export default {
  components: {
    VideoScale
  },
  data() {
    return {
      // ai讲次id
      aiLessonId: 5704,
      lessonId: 1127530921,
      // 班型id
      classTypeId: 136682,
      lessonName: '这里是讲次名称哈哈哈',
      videoData: null,
      curTag: {},
      spinning: true,
      scriptJson: [],
      useEvent: getEvent(),
      eventList: [],
      curInteract: null,
      curEvent: null
    }
  },
  computed: {
    tags() {
      const { videoData } = this
      if (videoData) {
        return videoData.tags
      }
      return []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      fetch(`https://yapi.aixuexi.com/mock/787/bfe/itv/event`).then(response => response.json())
        .then(data => {
          const videoData = data.body
          console.log('videoData---->', videoData)
          const { scriptJson, videoUrl } = videoData
          this.videoData = videoData
          // 初始化播放器
          this.$refs.videoScale.playerInit({ scriptJson, videoUrl }).then(() => {
            // 播放器初始化完成
            this.spinning = false
          })
          const { useEvent } = this
          this.eventList = scriptJson.map(item => ({
            ...item,
            ...useEvent[item.type]
          }))
        })
    },
    tagClick(tag) {
      this.curTag = tag
      this.$refs.videoScale.voChangeTags([tag])
    },
    tagChange(tag) {
      this.curTag = tag
    },
    /**
     * 播放部分片段
     */
    playSomeTags() {
      const { tags } = this
      const someTags = [tags[1], tags[2]]
      this.$refs.videoScale.voChangeTags(someTags)
    },
    end() {
      this.curInteract = null
      this.curEvent = null
    },
    interactClick(item) {
      this.curEvent = item
      this.curInteract = item.component
    }
  }
}
</script>
<style lang="less" scoped>
.page-bottom {
  margin-top: 20px;
}
.event-table {
  width: 500px;
  border: 1px solid #DFE2E6;
  tr {
    th, td {
      border: 1px solid #DFE2E6;
      border-left: 0;
      border-top: 0;
      padding: 12px 8px;
    }
  }
}
.interact-wrap {
  position: fixed;
  left: 10vw;
  right: 10vw;
  top: 0;
  bottom: 0;
  pointer-events: auto;
  background-color: rgba(13, 15, 26, 0.8)
}
</style>